<template>
  <span class="emd-text _color_default">
    <template v-if="name">
      {{ $t(name) }}
    </template>
    <slot v-else></slot>
  </span>
</template>

<script>
import documentTitle from '@/utils/documentTitle.mixin'
export default {
  name: 'AppBreadcumbItem',
  props: {
    name: String
  },
  mixins: [documentTitle]
}
</script>

<i18n src="./breadcrumb.locale.json"></i18n>
